import Settings from 'configs/Settings';

export const DRIPPING_OPTION = {
  DEFINE_LATER: 'DEFINE_LATER',
  BY_DAYS: 'BY_DAYS',
  BY_DATE: 'BY_DATE'
};

export const DRIPPING_PARAMS = {
  [DRIPPING_OPTION.BY_DATE]: 'liberationDate',
  [DRIPPING_OPTION.BY_DAYS]: 'liberationDays',
  type: 'liberationType'
};

export const OPTIONS = [
  {
    value: DRIPPING_OPTION.DEFINE_LATER,
    name: 'define-later-dripping',
    label: 'content_list.content_duplication.dripping_undefined'
  },
  {
    value: DRIPPING_OPTION.BY_DAYS,
    name: 'day-dripping',
    label: 'dripping.days.title',
    icon: 'calendar-alt'
  },
  {
    value: DRIPPING_OPTION.BY_DATE,
    name: 'date-dripping',
    label: 'content_list.content_duplication.dripping_date',
    icon: 'calendar-day'
  }
];

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const DAYS_OPTIONS = [7, 14, 30, 60];

export const DUPLICATION_STATUS = {
  FAILED: 'ERROR',
  FINISHED: 'SUCCESS'
};

export const api = {
  connect: `${Settings.api.duplicationWs}/public/ws`,
  createDuplicationTopic: '/ui/public/ws',
  subscribeDuplicationTopic: '/content-duplication/status/'
};
